import { render, staticRenderFns } from "./SearchFilterSavedFiltersMenu.vue?vue&type=template&id=89d7356c&scoped=true"
import script from "./SearchFilterSavedFiltersMenu.vue?vue&type=script&lang=js"
export * from "./SearchFilterSavedFiltersMenu.vue?vue&type=script&lang=js"
import style0 from "./SearchFilterSavedFiltersMenu.vue?vue&type=style&index=0&id=89d7356c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d7356c",
  null
  
)

export default component.exports